import * as mutations from "./mutation-types";
import api from "@/api";

// Transforms
export const transformParticipants = (participants = []) => {
  return participants.map(participant => transformParticipant(participant));
};

export const transformParticipant = (participant = {}) => {
  const friendList = participant.friendList || {};

  participant.friendListId = friendList.id;
  return participant;
};

export const transformFriendLists = (friendLists = []) => {
  return friendLists.map(friendList => transformFriendList(friendList));
};

export const transformFriendList = (friendlist = {}) => {
  const customer = friendlist.customer || {};
  const level = friendlist.level || {};

  friendlist.customerFirstName = customer.firstName;
  // friendlist.customerId = customer.id;
  friendlist.levelId = level.id;

  return friendlist;
};

export const getFriendList = async ({ commit }, id) => {
  let res = await api.friendList.get(id);
  commit(mutations.ADD_FRIEND_LISTS, transformFriendList(res.data));

  return res;
};

export const getMyFriendList = async ({ dispatch, state }) => {
  return await dispatch("getFriendList", state.myFriendListId);
};

export const getInvitedFriendList = async ({ dispatch, state }) => {
  return await dispatch("getFriendList", state.invitedFriendListId);
};

export const getFriendLists = async ({ commit }) => {
  let response = await api.friendList.all();
  commit(
    mutations.SET_FRIEND_LISTS,
    transformFriendLists(response.data["hydra:member"])
  );

  return response;
};

export const getFriendListLevels = async ({ commit }, id) => {
  let response = await api.friendList.level.all(id);
  commit(mutations.SET_FRIEND_LIST_LEVELS, {
    id,
    levels: response.data["hydra:member"],
  });

  return response;
};

export const getFriendListLevel = async ({ commit }, { friendListId, id }) => {
  let res = await api.friendList.level.get(friendListId, id);
  commit(mutations.ADD_FRIEND_LIST_LEVEL, { friendListId, level: res.data });

  return res;
};

export const getMyFriendListLevels = async ({ state, dispatch }) => {
  return await dispatch("getFriendListLevels", state.myFriendListId);
};

export const getMyFriendListLevel = async ({ state, dispatch }, id) => {
  if (!state.myFriendListId) {
    return Promise.resolve(null);
  }

  return dispatch("getFriendListLevel", {
    friendListId: state.myFriendListId,
    id,
  });
};

export const patchFriendList = async ({ commit }, { id, data }) => {
  let response = await api.friendList.patch(id, data);
  commit(mutations.ADD_FRIEND_LISTS, response.data);

  return response;
};

export const getFriendListParticipants = async ({ commit }, id) => {
  let res = await api.friendList.participant.all(id);
  commit(mutations.SET_FRIEND_LIST_PARTICIPANTS, {
    id,
    participants: transformParticipants(res.data["hydra:member"]),
  });

  return res;
};

export const getFriendListParticipant = async (
  { commit },
  { friendListId, id }
) => {
  let res = await api.friendList.participant.get(friendListId, id);
  commit(mutations.ADD_FRIEND_LIST_PARTICIPANT, {
    id: friendListId,
    participant: transformParticipant(res.data),
  });

  return res;
};

export const getMyFriendListParticipants = async ({ state, dispatch }) => {
  if (!state.myFriendListId) {
    return Promise.resolve([]);
  }

  return dispatch("getFriendListParticipants", state.myFriendListId);
};

export const getInvitedFriendListParticipants = async ({ state, dispatch }) => {
  if (!state.invitedFriendListId) {
    return Promise.resolve([]);
  }

  return dispatch("getFriendListParticipants", state.invitedFriendListId);
};

export const getMyFriendListParticipant = async ({ state, dispatch }, id) => {
  return dispatch("getFriendListParticipant", {
    friendListId: state.myFriendListId,
    id,
  });
};

export const deleteFriendListParticipant = async (
  { commit },
  { friendListId, id }
) => {
  let res = await api.friendList.participant.delete(friendListId, id);
  commit(mutations.DELETE_FRIEND_LIST_PARTICIPANT, {
    friendListId,
    id,
  });

  return res;
};

export const deleteMyFriendListParticipant = async (
  { state, dispatch },
  id
) => {
  return dispatch("deleteFriendListParticipant", {
    friendListId: state.myFriendListId,
    id,
  });
};

export const getFriendListInvite = async (context, code) => {
  return await api.friendList.invite.get(code);
};

export const validateFriendListInvite = async (context, code) => {
  return await api.friendList.invite.validate(code);
};

export const acceptFriendListInvite = async (context, code) => {
  return await api.friendList.invite.accept(code);
};
